module.exports = __webpack_public_path__ + "static/media/HAUX_MAIS_VIDA_2.13d805de.pdf";